import React from 'react';
import ErrorFeedbackBar from '.././global/ErrorFeedbackBar';
import {
  TICKET_OUT_PAGES,
  TICKET_SETTINGS_ROLES,
  DEFAULT_TICKET_PHOTO_SETTING,
} from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { companySelector } from '../../redux/selectors/account';
import { clearStatus } from '../../redux/actions/global';
import { userInfoSelector } from '../../redux/selectors/auth';
import TicketOutTable from './TicketOutTable';
import TicketOutSettings from './TicketOutSettings';
import compressTicketPhoto from './compressTicketPhoto';
import { Button, TextField, Dialog } from '@material-ui/core';
import {
  deleteTicketOut,
  getGlobalPDFPreview,
  getTicketPhotoSetting,
  listTicketOut,
  resetGlobalPdfPreviewData,
  saveTicketOut,
} from '../../redux/actions/ticketOut';
import {
  globalPDFPreviewReadySelector,
  ticketOutSelector,
  ticketPhotoSettingSelector,
} from '../../redux/selectors/ticketOut';
import InputAdornment from '@material-ui/core/InputAdornment';
import { DEFAULT_PDF_ZOOM } from '../raffle/constants';
import Utils from '../Utils/Utils';
import AuthUtil from '../../redux/AuthUtil';
import { TICKET_OUT } from '../global/Server/endpoints';
import RenderPurchaseOrderPDFPreview from '../transaction/RenderPurchaseOrderPDFPreview';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../reading/masterReading/constants';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SettingsIcon from '@material-ui/icons/Settings';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import CustomToolbar from '../global/CustomToolbar';

class TicketOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: TICKET_OUT_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      ticketOut: '',
      machine: '',
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      requiredList: ['machine', 'ticketOut'],
      //report
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      saving: false,
      waiting: false,
      // Photo requirement
      currentPhoto: null,
      photoPreviewUrl: null,
      photoError: null,
      // Live camera capture (mirrors Bonus)
      isCameraOpen: false,
      cameraFacingMode: 'environment',
      // Photo viewer (table "View" link)
      showPhotoViewer: false,
      photoViewerSrc: null,
    };

    this.amountRef = React.createRef();
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  componentWillUnmount() {
    this.stopCamera();
  }

  componentDidMount() {
    this.props.listTicketOut({
      userId: this.props.user.userId,
      locationId: this.props.user.selectedLocationId,
    });
    this.props.getTicketPhotoSetting({
      locationId: this.props.user.selectedLocationId,
    });
    if (this.hasTicketNFCRole()) {
      // Get query params from URL
      const queryParams = new URLSearchParams(window.location.search);
      const machine = queryParams.get('machine');

      if (machine) {
        this.setState({ machine }, () => {
          // Focus on amount input
          if (this.amountRef.current) {
            this.amountRef.current.focus();
          }
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  handleClick = (value) => {
    this.setState((prevState) => ({
      amounts: {
        ...prevState.amounts,
        [value]: prevState.amounts[value] + 1,
      },
      ticketOut: Number(prevState.ticketOut) + Number(value), // Ensure both are treated as numbers
    }));
  };

  clearAmounts = () => {
    this.setState({
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      ticketOut: '',
    });
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displayTable = () => {
    return (
      <TicketOutTable
        userInfo={this.props.user}
        deleteTicketOut={this.props.deleteTicketOut}
        ticketOut={this.props.ticketOut}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        onViewPhoto={this.onViewPhoto}
        isBonusView={this.state.isBonusView}
        claimBonus={this.props.claimBonus}
        handleEditBonusRow={this.handleEditBonusRow}
        isPreviewImage={this.state.isPreviewImage}
        image={this.state.image}
      />
    );
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case TICKET_OUT_PAGES.TABLE:
        return this.displayTable();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  hasTicketNFCRole = () => {
    const { user, companies } = this.props;
    const roles = user?.authority || [];
    if (!roles.includes('ROLE_TICKET_NFC')) return false;

    // Per-location opt-out: if the currently selected location's company
    // has nfcTicketOutEnabled === false, treat NFC as disabled so the
    // Machine field stays manually editable.
    const locationId = user?.selectedLocationId;
    const currentCompany = (companies || []).find(
      (c) => c.companyId === locationId
    );
    if (currentCompany && currentCompany.nfcTicketOutEnabled === false) {
      return false;
    }
    return true;
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    // Ensure the value is a positive integer or empty
    const reg = /^[0-9\b]+$/; // Regex to allow only digits and empty input (for clearing the field)

    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  clearFields = () => {
    this.clearPhoto();
    this.setState({ machine: '' }, () => {
      this.clearAmounts();
    });
  };

  // ── Photo requirement helpers ─────────────────────────────────────────

  canManageSettings = () => {
    const roles = this.props.user?.authority || [];
    return TICKET_SETTINGS_ROLES.some((role) => roles.includes(role));
  };

  getSetting = () => this.props.ticketPhotoSetting || DEFAULT_TICKET_PHOTO_SETTING;

  // needsPhoto = enabled AND amount >= threshold (spec §4.1)
  isPhotoRequired = () => {
    const setting = this.getSetting();
    const amount = Number(this.state.ticketOut) || 0;
    return !!setting.enabled && amount >= Number(setting.thresholdAmount || 0);
  };

  openSettings = () => {
    this.setCurrentPage(TICKET_OUT_PAGES.SETTINGS);
  };

  // ── Live camera capture (mirrors the Bonus capture flow) ──────────────

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    if (this.videoRef.current) this.videoRef.current.srcObject = null;
    this.setState({ isCameraOpen: false });
  };

  startCamera = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }

      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { min: 1024, ideal: 1920, max: 3840 },
          height: { min: 720, ideal: 1080, max: 2160 },
          frameRate: { ideal: 60 },
        },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities ? track.getCapabilities() : {};
      if (capabilities.focusMode?.includes('continuous')) {
        await track.applyConstraints({ advanced: [{ focusMode: 'continuous' }] });
      }

      this.setState({ isCameraOpen: true, photoError: null });
      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  switchCamera = () => {
    const nextFacingMode =
      this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';
    this.setState({ cameraFacingMode: nextFacingMode }, () => {
      if (this.state.isCameraOpen) this.startCamera();
    });
  };

  handleOpenCamera = () => {
    if (!this.state.isCameraOpen) this.startCamera();
  };

  capturePhoto = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    if (!canvas || !video) return;

    const vWidth = video.videoWidth;
    const vHeight = video.videoHeight;
    const screenAspectRatio = window.innerWidth / window.innerHeight;
    const videoAspectRatio = vWidth / vHeight;

    let sWidth, sHeight, sx, sy;
    if (videoAspectRatio > screenAspectRatio) {
      sWidth = vHeight * screenAspectRatio;
      sHeight = vHeight;
      sx = (vWidth - sWidth) / 2;
      sy = 0;
    } else {
      sWidth = vWidth;
      sHeight = vWidth / screenAspectRatio;
      sx = 0;
      sy = (vHeight - sHeight) / 2;
    }

    canvas.width = sWidth;
    canvas.height = sHeight;

    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(video, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);

    const imageURL = canvas.toDataURL('image/jpeg', 0.8);
    this.stopCamera();
    this.handleCapturedDataUrl(imageURL);
  };

  // Convert the captured data URL into a File, then run it through the
  // shared compressor so the 1600px / 0.8 / 5MB rules (spec §5) still apply.
  handleCapturedDataUrl = async (dataUrl) => {
    try {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `ticket-${Date.now()}.jpeg`, {
        type: 'image/jpeg',
      });
      const compressed = await compressTicketPhoto(file);
      if (this.state.photoPreviewUrl) {
        URL.revokeObjectURL(this.state.photoPreviewUrl);
      }
      this.setState({
        currentPhoto: compressed,
        photoPreviewUrl: URL.createObjectURL(compressed),
        photoError: null,
      });
    } catch (message) {
      this.setState({
        currentPhoto: null,
        photoPreviewUrl: null,
        photoError:
          typeof message === 'string' ? message : 'Could not process the photo, please retake.',
      });
    }
  };

  clearPhoto = () => {
    this.stopCamera();
    if (this.state.photoPreviewUrl) {
      URL.revokeObjectURL(this.state.photoPreviewUrl);
    }
    this.setState({ currentPhoto: null, photoPreviewUrl: null, photoError: null });
  };

  onViewPhoto = (ticket) => {
    AuthUtil.postRequest(TICKET_OUT.PREVIEW_PHOTO, { ticketId: ticket?.ticketId })
      .then((res) => {
        if (res.data && res.data.success && res.data.previewedFile) {
          const blob = new Blob([new Uint8Array(res.data.previewedFile)], {
            type: 'image/jpeg',
          });
          this.setState({
            photoViewerSrc: URL.createObjectURL(blob),
            showPhotoViewer: true,
          });
        } else {
          this.openFeedbackBar('error', 'Photo not available');
        }
      })
      .catch(() => this.openFeedbackBar('error', 'Failed to load photo'));
  };

  closePhotoViewer = () => {
    if (this.state.photoViewerSrc) {
      URL.revokeObjectURL(this.state.photoViewerSrc);
    }
    this.setState({ showPhotoViewer: false, photoViewerSrc: null });
  };

  addTicket = () => {
    if (this.state.saving || this.state.waiting) return;

    this.setState({ saving: true });

    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', response);
        this.clearFields(); // only clear on success
      }

      // finish saving + start waiting in one atomic update
      this.setState({ saving: false, waiting: true }, () => {
        // wait 2 seconds before allowing next save
        setTimeout(() => {
          this.setState({ waiting: false });
        }, 2000);
      });
    };

    this.props.saveTicketOut(
      {
        machine: this.state.machine,
        ticketOut: this.state.ticketOut,
        userId: this.props.user.userId,
        locationId: this.props.user.selectedLocationId,
        amounts: this.state.amounts,
        photo: this.state.currentPhoto || undefined,
      },
      callback
    );
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  fetchPdf = async () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    this.props.getGlobalPDFPreview(
      {
        userId: this.props.user.userId,
        locationId: this.props.user.selectedLocationId,
        date: getTodayDate,
      },
      this.showPdfErrorMessage,
      'previewTicketOutReport'
    );
    this.setState({ showPdfViewer: true });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.user.firstname} Ticket Out Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  render() {
    const { amounts, showPdfViewer, pdfData, scale } = this.state;
    const isSettings = this.state.currentPage === TICKET_OUT_PAGES.SETTINGS;
    const needsPhoto = this.isPhotoRequired();
    const setting = this.getSetting();

    let headerButtons;
    headerButtons = [];
    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (isSettings) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        title: 'Back to Ticket Out',
        handler: () => this.setCurrentPage(TICKET_OUT_PAGES.TABLE),
      });
    } else {
      if (!this.state.isPreviewImage && !this.state.isMobile) {
        headerButtons.push({
          icon: <VisibilityIcon />,
          title: 'View Report',
          handler: () => this.fetchPdf(),
        });
      }
      // Gear icon — Ticket Settings. Hidden for plain employees (spec §3, §8.3).
      if (this.canManageSettings()) {
        headerButtons.push({
          icon: <SettingsIcon />,
          title: 'Ticket Settings',
          handler: () => this.openSettings(),
        });
      }
    }

    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <CustomToolbar
          title={
            isSettings
              ? 'Ticket Settings'
              : `Ticket Out (${this.props.user.firstname})`
          }
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : isSettings ? (
          <TicketOutSettings openFeedbackBar={this.openFeedbackBar} />
        ) : (
          <>
            <div className="rowSpecMaster">
              <TextField
                className="input-text-field"
                variant="outlined"
                label="Machine"
                InputLabelProps={{ shrink: true }}
                name="machine"
                value={this.state.machine}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('machine')}
                type="tel"
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  min: '0',
                  step: '1',
                }}
                disabled={this.hasTicketNFCRole()}
              />

              <TextField
                className="input-text-field"
                variant="outlined"
                label="Amount"
                InputLabelProps={{ shrink: true }}
                name="ticketOut"
                value={this.state.ticketOut}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('ticketOut')}
                type="tel"
                inputRef={this.amountRef}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  min: '0',
                  step: '1',
                }}
              />
            </div>

            <div className="amount-buttons">
              <div style={{ marginBottom: '20px' }}>
                {Object.keys(amounts).map((amount) => (
                  <button
                    key={amount}
                    onClick={() => this.handleClick(amount)}
                    style={{
                      margin: '5px',
                      padding: '10px 20px',
                      backgroundColor: '#2596be',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    {amount}
                  </button>
                ))}

                <button
                  onClick={this.clearAmounts}
                  style={{
                    margin: '5px',
                    padding: '10px 20px',
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  CLR
                </button>
              </div>
            </div>

            {needsPhoto && (
              <div className="photo-required-panel">
                <div className="photo-required-header">
                  <WarningIcon style={{ color: '#d97706' }} />
                  <div>
                    <p className="photo-required-title">Photo Required</p>
                    <p className="photo-required-text">
                      This ticket is at or above ${setting.thresholdAmount}. A
                      photo of the ticket is required before adding.
                    </p>
                  </div>
                </div>

                {this.state.currentPhoto ? (
                  <div className="photo-preview-wrap">
                    <img
                      className="photo-preview-img"
                      src={this.state.photoPreviewUrl}
                      alt="Ticket"
                    />
                    <div className="photo-preview-actions">
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<PhotoCameraIcon />}
                        onClick={this.handleOpenCamera}
                      >
                        Retake
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        style={{ color: '#dc2626', borderColor: '#fca5a5' }}
                        onClick={this.clearPhoto}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    startIcon={<PhotoCameraIcon />}
                    onClick={this.handleOpenCamera}
                  >
                    Take Photo
                  </Button>
                )}

                {this.state.photoError && (
                  <p
                    className="photo-required-text"
                    style={{ color: '#dc2626' }}
                  >
                    {this.state.photoError}
                  </p>
                )}
              </div>
            )}

            <div className="button-ticket">
              <Button
                variant="outlined"
                onClick={this.clearFields}
                className="register-new-user_btn"
              >
                CLEAR
              </Button>
              <Button
                className="register-new-user_btn"
                variant="contained"
                color="primary"
                onClick={() => this.addTicket()}
                disabled={
                  !(this.state.machine && this.state.ticketOut) ||
                  (needsPhoto && !this.state.currentPhoto) ||
                  this.state.saving ||
                  this.state.waiting
                }
              >
                {this.state.saving ? 'SAVING...' : 'ADD TICKET'}
              </Button>
            </div>

            {this.displayCurrentPage()}
          </>
        )}

        <Dialog
          open={this.state.showPhotoViewer}
          onClose={this.closePhotoViewer}
          maxWidth="md"
        >
          {this.state.photoViewerSrc && (
            <img
              src={this.state.photoViewerSrc}
              alt="Ticket"
              style={{ maxWidth: '90vw', maxHeight: '85vh', display: 'block' }}
            />
          )}
        </Dialog>

        {/* Full-screen live camera overlay (mirrors Bonus capture UX) */}
        {this.state.isCameraOpen && (
          <div className="camera-view-container">
            <video
              ref={this.videoRef}
              autoPlay
              playsInline
              muted
              className="video-ref"
            />
            <button
              type="button"
              onClick={this.stopCamera}
              className="camera-close-button"
              aria-label="Close Camera"
            >
              <CloseIcon />
            </button>
            <button
              type="button"
              onClick={this.capturePhoto}
              className="capture-button"
              aria-label="Capture Photo"
            >
              <span className="capture-icon"></span>
            </button>
            <button
              type="button"
              onClick={this.switchCamera}
              className="flip-camera-button"
              aria-label="Switch Camera"
            >
              <FlipCameraIosIcon />
            </button>
          </div>
        )}
        <canvas ref={this.canvasRef} style={{ display: 'none' }} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  ticketOut: ticketOutSelector(state),
  ticketPhotoSetting: ticketPhotoSettingSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  companies: companySelector(state),
});

const actionCreators = {
  clearStatus,
  listTicketOut,
  deleteTicketOut,
  saveTicketOut,
  getTicketPhotoSetting,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  TicketOut
);
